(() => {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeModal = null;
  let lastTrigger = null;

  const closeModal = (modal = activeModal) => {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('kizzu-modal-open');
    activeModal = null;

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;

    if (activeModal && activeModal !== modal) closeModal(activeModal);

    lastTrigger = trigger;
    activeModal = modal;
    modal.hidden = false;
    document.documentElement.classList.add('kizzu-modal-open');

    requestAnimationFrame(() => {
      const firstFocusable = modal.querySelector(focusableSelector);
      firstFocusable?.focus();
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-kizzu-modal-open]');
    if (trigger) {
      const modal = document.getElementById(trigger.dataset.kizzuModalOpen);
      openModal(modal, trigger);
      return;
    }

    const close = event.target.closest('[data-kizzu-modal-close]');
    if (close) closeModal(close.closest('[data-kizzu-modal]'));
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...activeModal.querySelectorAll(focusableSelector)].filter(
      (element) => !element.hasAttribute('hidden') && element.offsetParent !== null
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
